import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { SlidesLayout } from "./SlidesLayout";

import { DoorWidthControls } from "features/option-controls/door-width-controls/DoorWidthControls";
import {
  AllXLXXLDoorCodes,
  enabledXLXXLDeMaasDeWaalNewDoors,
} from "features/option-controls/door-width-controls/XLXXLHelper";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { useState } from "react";
import OptionTemplate from "shared/ui/option-template";
import { MobileLayoutList } from "../MobileLayoutList";
import { MobileSelfAssemblyBlock } from "../MobileSelfAssemblyBlock";
import { MobileSelfAssemblyPage } from "../MobileSelfAssemblyPage";
import { useOptionModalSetter } from "../MobileConfiguratorModalTemplate";

const selfAssemblyEase = [0.22, 1, 0.36, 1] as const;
const selfAssemblyTransition = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.18, ease: selfAssemblyEase },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: selfAssemblyEase },
  },
};

export const LayoutSelector = () => {
  const { selectedDoor, isNotMaasWaalIjsselLayout, selfAssembleDoorData } =
    useConfigurationOptionsContext();

  const [selfAssemblyPageOpen, setSelfAssemblyPageOpen] = useState(false);
  const showXLXXLScene =
    selectedDoor?.code &&
    AllXLXXLDoorCodes.includes(selectedDoor.code) &&
    (isNotMaasWaalIjsselLayout ||
      enabledXLXXLDeMaasDeWaalNewDoors.includes(selectedDoor.code));

  const setOptionModalState = useOptionModalSetter();
  return (
    <SlidesLayout id="layout-selector">
      <AnimatePresence mode="wait">
        <LayoutGroup>
          <motion.div
            key={
              selfAssembleDoorData && selfAssemblyPageOpen
                ? "selfAssembly"
                : "nonselfAssembly"
            }
            {...selfAssemblyTransition}
          >
            {selfAssembleDoorData.selfAssembly && selfAssemblyPageOpen ? (
              <MobileSelfAssemblyPage
                setSelfAssemblyPageOpen={setSelfAssemblyPageOpen}
                setOptionModalState={setOptionModalState}
              />
            ) : (
              <>
                <MobileLayoutList />

                {showXLXXLScene && (
                  <OptionTemplate
                    title="Breedte deur"
                    description="Wil je een normale afmeting deur, of wil je een hele grote deur? Aan jou de keuze."
                    testId="door-color-width"
                    onShowInfoClick={() =>
                      setOptionModalState({
                        isOpen: true,
                        heading: "Breedte deur",
                        description:
                          "Alle deuren worden per bestelling op maat gemaakt. Is jouw deur breder dan 115 centimeter, dan heet dat bij ons een XL deur. Is jouw deur breder dan 145 centimeter? Dan is jouw deur een XXL variant.",
                      })
                    }
                  >
                    <DoorWidthControls />
                  </OptionTemplate>
                )}

                <MobileSelfAssemblyBlock
                  setSelfAssemblyPageOpen={setSelfAssemblyPageOpen}
                  setOptionModalState={setOptionModalState}
                />
              </>
            )}
          </motion.div>
        </LayoutGroup>
      </AnimatePresence>
    </SlidesLayout>
  );
};
